import { format, parseISO } from 'date-fns';
import { APP_NAME } from '../config/constants';

export const generateBillHtml = (bill, salesDetails, language = 'tamil') => {
  const billDate = bill.billDate ? format(parseISO(bill.billDate), 'dd/MM/yyyy') : format(new Date(), 'dd/MM/yyyy');

  const itemsHtml = salesDetails.map((item, index) => {
    let rateToDisplay;
    if (item.salesPrice !== null && item.salesPrice !== undefined && item.salesPrice !== '') {
      rateToDisplay = Number(item.salesPrice);
    } else if (item.actualPrice !== null && item.actualPrice !== undefined && item.actualPrice !== '') {
      rateToDisplay = Number(item.actualPrice);
    } else {
      rateToDisplay = 0;
    }

    const productName = language === 'english'
      ? item.productNameEnglish || item.productName
      : item.productNameTamil || item.productName;

    return `
      <tr>
        <td>${productName}</td>
        <td class="text-right">${rateToDisplay.toFixed(2)}</td>
        <td class="text-right">${item.quantity}</td>
        <td class="text-right">${(Number(item.price) || 0).toFixed(2)}</td>
      </tr>
    `;
  }).join('');

  let totalsHtml;

  // Quick Bill ('Q') - Simplified View
  if (bill.billTypeFlag === 'Q') {
    totalsHtml = `
      <tr>
        <td class="label" style="font-weight: bold; font-size: 1.2em; border-top: 2px solid #e0e0e0;">Total</td>
        <td class="value" style="font-weight: bold; font-size: 1.2em; border-top: 2px solid #e0e0e0;">${(Number(bill.billAmount) || 0).toFixed(2)}</td>
      </tr>
    `;
  }
  // Customer Bill ('C') - Detailed View with Payment Info
  else if (bill.billTypeFlag === 'C') {
    const receivedAmountRow = (bill.isPaid === 'Y')
      ? `
        <tr>
          <td class="label">Amount Paid</td>
          <td class="value">${(Number(bill.receivedAmount) || 0).toFixed(2)}</td>
        </tr>
      `
      : '';

    const amountToPay = bill.cumulativeBalance !== undefined
      ? Number(bill.cumulativeBalance)
      : Number(bill.cumulativeBalance || 0);

    totalsHtml = `
      <tr>
        <td class="label">Total</td>
        <td class="value">${(Number(bill.billAmount) || 0).toFixed(2)}</td>
      </tr>
      <tr>
        <td class="label">Old Balance</td>
        <td class="value">${(Number(bill.oldBalance) || 0).toFixed(2)}</td>
      </tr>
      ${receivedAmountRow}
      <tr class="balance">
        <td class="label">Amount to pay</td>
        <td class="value">${amountToPay.toFixed(2)}</td>
      </tr>
    `;
  }
  // Product Bill ('P') and other defaults - Detailed View without Payment Info
  else {
    const amountToPay = bill.cumulativeBalance !== undefined
      ? Number(bill.cumulativeBalance)
      : Number(bill.cumulativeBalance || 0);

    totalsHtml = `
      <tr>
        <td class="label">Total</td>
        <td class="value">${(Number(bill.billAmount) || 0).toFixed(2)}</td>
      </tr>
      <tr>
        <td class="label">Old Balance</td>
        <td class="value">${(Number(bill.oldBalance) || 0).toFixed(2)}</td>
      </tr>
      <tr class="balance">
        <td class="label">Amount to pay</td>
        <td class="value">${amountToPay.toFixed(2)}</td>
      </tr>
    `;
  }

  // Return only the invoice container HTML, not the full page boilerplate
  return `
    <div class="invoice-container">
        <style>
            .bill-table td, .bill-table th {
                padding: 2px 4px !important;
                font-size: 15px !important;
                line-height: 2 !important;
            }
            .bill-table {
                margin-bottom: 2px !important;
            }
            .details-section {
                margin-top: 3px !important;
                margin-bottom: 3px !important;
            }
            .header {
                margin-bottom: 2px !important;
            }
            .header h1, .header p {
                margin: 0 !important;
                line-height: 1.5 !important;
            }
            .totals-table td {
                padding: 0 2px !important;
                font-size: 13px !important;
                line-height: 2 !important;
            }
            .totals-table .value {
                font-weight: bold !important;
            }
        </style>
        <div class="header">
            <div class="business-details">
                <h1>${APP_NAME}</h1>
                <p>காய் கனி மொத்தம் & சில்லறை வியாபாரம்</p>
                <p>ஒழுகினசேரி, அப்டா மார்க்கெட்</p>
            </div>
            <div class="contact-info">
                <p>செல் : 9787319455</p>
                <p class="owner">உரிமையாளர்: R.ராஜாராம்</p>
                <p class="owner">V.R.நிலேஷ்</p>
            </div>
        </div>
        <div class="details-section">
            <div>Name: <strong>${bill.customerNameTamil || bill.customerName || ''}</strong></div>
            <div>Bill No: <strong>${bill.manualBillNo || ''}</strong></div>
            <div>Date: <strong>${billDate}</strong></div>
        </div>
        <table class="bill-table">
            <thead>
                <tr>
                    <th>PARTICULARS</th>
                    <th class="text-right">RATE</th>
                    <th class="text-right">QTY</th>
                    <th class="text-right">AMOUNT</th>
                </tr>
            </thead>
            <tbody>
                ${itemsHtml}
            </tbody>
        </table>
        <div class="totals-section" style="display: flex; justify-content: space-between;">
            <div style="text-align: left; font-weight: bold; font-size: 12px; margin-top: 5px;">Total Items: ${salesDetails.length}</div>
            <table class="totals-table">
                <tbody>
                    ${totalsHtml}
                </tbody>
            </table>
        </div>
        <div class="footer">
            <p>For ${APP_NAME}</p>
        </div>
    </div>
  `;
};
